import React from 'react';

import { TextField, useRecordContext } from 'react-admin';

import { get, isEmpty } from 'lodash';

import { Typography } from '@mui/material';

import Answer from '../Answer';

import languages, { Languages } from '../../../../constants/languages';
import conflictFields from '../../../../constants/conflictFields';
import questionElementTypes from '../../../../constants/questionElementTypes';
import { PreviousTurnoverParameters } from '../../questionParameters';

const VALUE_LABEL = {
  [languages.SV]: 'Företagets senaste årsomsättning.',
  [languages.EN]: 'Company’s most recent yearly turnover',
  [languages.DE]: 'Letzter Jahresumsatz des Unternehmens',
};

const ValueField = ({
  extraParameters,
}: {
  extraParameters?: PreviousTurnoverParameters;
}) => {
  const record = useRecordContext();

  const valueObj = get(record, 'value');
  const sx = get(record, 'sx', {});

  if (isEmpty(valueObj)) return <Typography>-</Typography>;

  let value = '';
  const defaultValue = `${valueObj.value} ${valueObj.currency}`;
  if (extraParameters?.type === questionElementTypes.SELECT && extraParameters?.options) {
    const option = extraParameters.options.find(({ id }) => id === valueObj.value);
    value = option
      ? extraParameters.choiceLabels?.[String(option.id)] ?? option.label
      : defaultValue;
  } else {
    value = defaultValue;
  }

  return <TextField record={{ value }} sx={sx} source="value" emptyText="-" fontWeight="bold" />;
};

const PreviousTurnover = ({ extraParameters }: {
  extraParameters?: PreviousTurnoverParameters;
}) => {
  const record = useRecordContext();

  const language = record?.language as Languages;

  return (
    <Answer
      label={extraParameters?.label ?? VALUE_LABEL[language]}
      source="previousTurnover"
      datapoint={conflictFields.PREVIOUS_TURNOVER}
      identificationInfo={undefined}
    >
      <ValueField extraParameters={extraParameters} />
    </Answer>
  );
};

PreviousTurnover.ValueField = ValueField;

export default PreviousTurnover;
